export const offices = [
  {
    id: 0,
    name: "全事業所",
    shortName: "全事業所",
  },
  {
    id: 1,
    name: "岐阜支店",
    shortName: "岐阜",
  },
  {
    id: 2,
    name: "東京支店",
    shortName: "東京",
  },
  {
    id: 3,
    name: "福岡支店",
    shortName: "福岡",
  },
  {
    id: 4,
    name: "大阪支店",
    shortName: "大阪",
  },
  {
    id: 5,
    name: "熊本営業所",
    shortName: "熊本",
  },
  {
    id: 6,
    name: "鹿児島営業所",
    shortName: "鹿児島",
  },
  {
    id: 7,
    name: "広島営業所",
    shortName: "広島",
  },
  {
    id: 8,
    name: "名古屋支店",
    shortName: "名古屋",
  },
  {
    id: 9,
    name: "北関東営業所",
    shortName: "北関東",
  },
  {
    id: 11,
    name: "東北営業所",
    shortName: "東北",
  },
  {
    id: 12,
    name: "長野営業所",
    shortName: "長野",
  },
  {
    id: 13,
    name: "金沢営業所",
    shortName: "金沢",
  },
  {
    id: 14,
    name: "高松営業所",
    shortName: "高松",
  },
  {
    id: 15,
    name: "宮崎営業所",
    shortName: "宮崎",
  },
  {
    id: 16,
    name: "静岡営業所",
    shortName: "静岡",
  },
  {
    id: 17,
    name: "札幌出張所",
    shortName: "札幌",
  },
  {
    id: 18,
    name: "沖縄営業所",
    shortName: "沖縄",
  },
  //   {
  //     id: 35,
  //     name: "海外事業部",
  //   },
  //   {
  //     id: 40,
  //     name: "プラント事業部",
  //   },
  //   {
  //     id: 46,
  //     name: "航空宇宙事業部",
  //   },
];
